import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import { MdCheck, MdErrorOutline } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const EmailVerified = () => {
    const { t } = useLanguage()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    const [status, setStatus] = useState("verifying");
    const [err, setErr] = useState({ message: "", display: false });

    useEffect(() => {
        const verifyEmail = async () => {
            if (!email) {
                setStatus("error");
                setErr({
                    message: "Invalid or missing verification email.",
                    display: true
                });
                return;
            }

            try {
                const response = await fetch(
                    `${GEN_BACKEND_LINK}/verify_email`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ email, token }),
                    }
                );

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.error || "Verification failed");
                }

                if (data.message !== "OK") {
                    throw new Error("Unexpected server response");
                }

                const account_id = data.account_id;
                document.cookie = `account_id=${account_id}; path=/; max-age=` + (7 * 24 * 60 * 60);
                localStorage.setItem("account_id", account_id);
                setStatus("success");

                setTimeout(() => {
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        if (data.email_verified) {
                            if (data.onboarding.completed) {
                                navigate("/console/organizations");
                            } else {
                                navigate(`/onboarding/welcome`);
                            }
                        } else {
                            navigate(`/verify-email?email=${email}`);
                        }
                    }
                }, 3000);


            } catch (error) {
                setStatus("error");

                setErr({
                    message: "Something went wrong. Please try again later.",
                    display: true,
                });
            }
        };

        verifyEmail();
    }, [email]);

    return (
        <div className="verify_email_cont">

            {status === "verifying" && (
                <>
                    <p className="verify_email_title fade-in">{t.verification.title}</p>
                    <Spinner loading={true} />
                </>
            )}

            {status === "success" && (
                <>
                    <p className="verify_email_title fade-in"><MdCheck /></p>
                    <p className="verify_email_title fade-in">{t.verification.verified_title}</p>
                    <p className="verify_email_subtitle fade-in">{t.verification.verified_subtitle}</p>
                </>
            )}

            {status === "error" && (
                <>
                    <p className="verify_email_title fade-in"><MdErrorOutline /></p>
                    <p className="verify_email_title fade-in">{t.verification.failed_verified_title}</p>
                    <p className="verify_email_subtitle fade-in">{t.verification.failed_verified_subtitle}</p>
                    <p className="fade-in" id="privacy_policy_desc" dangerouslySetInnerHTML={{ __html: t.help }}></p>
                </>
            )}

        </div>
    );
};

export default EmailVerified;